/**
 * Matcher for source_type
 * @module
 */
var match = require('core/lib/match');

exports.fieldsNeeded = ['source_type'];

exports.match = function(value, cond) {
  return match.hasMatch(cond.value, cond.match, value.source_type);
};
